module.exports = __webpack_public_path__ + "cg.svg?5637992e76d5a600b5519987f82e1114";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/cg.svg
// module id = 968
// module chunks = 27